<template>
  <div style="background-color:#F5F6F7;min-height: 100vh;">
    <div class="type-menu">
      <div class="type-item" :class="{ active: type === item.type }" v-for="(item,index) in tabList" :key="index">
        <div @click="switchType(item.type)">
          <span>{{item.text}}</span>
        </div>
      </div>
    </div>
    <div class="list-block">
      <PolicyList :data-list="tempList" @loading="loadData" />
      <div class="orderimg" v-if="tempList.length===0">
        <img src="@/assets/img/user_center/order.png" alt="">
        <p>暂时还没有保单</p>
      </div>
    </div>
  </div>
</template>

<script>
import PolicyList from './component/PolicyList'
import { findUserInsurePersons } from '@/api/user'
import { AppCode, SetGetAuthInfo } from '@/util/auth'
import { mapState } from 'vuex'

export default {
  name: 'UserPolicy',
  components: {
    PolicyList
  },
  data() {
    return {
      type: '',
      tabList: [{
        type: 'all',
        text: '全部'
      }, {
        type: 'effective',
        text: '有效'
      }, {
        type: 'preEffective',
        text: '待生效'
      },{
        type: 'unEffective',
        text: '无效'
      }],
      policyList: [], // 所有数据(原数据)
      tempList: [], // 遍历筛选后的数据
      hasTeYaoFeeInsu: false
    }
  },
  computed: {
    ...mapState(['userInfo']),
  },
  mounted() {
    this.cookieUser = SetGetAuthInfo.getInfo()
    const { type } = this.$route.query
    const fromSourceCode = localStorage.getItem('fromSourceCode') || ''
    this.type = type || 'all'
    if (this.cookieUser.userId) {
      this.loadData()
      this.switchType(this.type)
    } else {
      this.$router.push({
        path: '/user-login',
        query: {
          fromSourceCode
        }
      })
    }
  },
  methods: {
    switchType(type) {
      this.type = type
      // 全部
      if (type == 'all') {
        console.log('all---');
        this.tempList = this.policyList
      }
      // 有效
      if (type == 'effective') {
        console.log('this.policyList---', this.policyList);
        this.tempList = this.policyList.filter(function (item) {
          console.log(item.insuranceStatus);
          return item.insuranceStatus == 'effective'
        })

        console.log('this.tempList---', this.tempList);
      }
      // 待生效
      if (type == 'preEffective') {
        console.log('this.policyList---', this.policyList);
        this.tempList = this.policyList.filter(function (item) {
          console.log(item.insuranceStatus);
          return item.insuranceStatus == 'preEffective'
        })
        console.log('this.tempList---', this.tempList);
      }
      // 无效
      if (type == 'unEffective') {
        console.log('unEffective---');
        this.tempList = this.policyList.filter(function (item) {
          return item.insuranceStatus === 'unEffective' || item.insuranceStatus === 'theEnd'
        })
      }
    },
    async loadData() {
      this.loading = true
      try {
        const res = await findUserInsurePersons({
          pageSize: 300,
          pageNum: 1,
          insuranceProductCode: process.env.VUE_APP_BAOSICODE,
          appCodeId: AppCode
        })
        this.tempList = this.policyList = res || []
      } catch (e) {
        this.$notify({ color: '#F4111F', background: '#FFEC70', message: e.message })
      }
      this.loading = false
    }
  }
}
</script>

<style scoped lang="scss">
.type-menu {
  display: flex;
  align-items: center;
  background-color: #fff;
  .type-item {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    height: 40px;
    > div {
      position: relative;
      text-align: center;
      font-size: 14px;
      color: #4c4c4c;
    }

    .arc-img {
      position: absolute;
      left: 0;
      bottom: 0;
      display: none;
      width: 100%;
    }
  }

  .type-item.active {
    > div {
      color: #f6303b;
    }
    &::after {
      position: absolute;
      content: '';
      left: 0;
      bottom: 0;
      width: 100%;
      height: 2px;
      background-color: #f4111f;
    }

    .arc-img {
      display: inline;
    }
  }
}

.list-block {
  width: 360px;
  margin: 10px auto 0;
  background-color: #f5f6f7;
  p {
    font-size: 16px;
  }
}

.orderimg {
  margin: 150px auto;
  text-align: center;
  img {
    width: 100px;
  }
}
</style>
